import { render } from "./createstockadjustment.vue?vue&type=template&id=1a00f838&scoped=true"
import script from "./createstockadjustment.vue?vue&type=script&lang=js"
export * from "./createstockadjustment.vue?vue&type=script&lang=js"

import "./createstockadjustment.vue?vue&type=style&index=0&id=1a00f838&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a00f838"]])

export default __exports__